import * as yup from 'yup';

export const VALIDATE_PASSWORD = yup.string().min(8, 'must be at least 8 characters').required('is required');
